import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const ProviderAccountModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  account_id: z.number().int(),
  is_blacklisted: z.boolean(),
  has_account: z.boolean(),
  airport_id: z.string().nullish(),
  name: z.string().nullish(),
  address: jsonSchema,
  provider_internal_account_id: z.string().nullish(),
})
